import { render, staticRenderFns } from "./monthly-training-tile.component.vue?vue&type=template&id=816d5528"
import script from "./monthly-training-tile.component.ts?vue&type=script&lang=ts&external"
export * from "./monthly-training-tile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./monthly-training-tile.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports